import { GetCapabilitiesResponse, UpdateCapabilityRequest } from '@amzn/finspace-service-typescript-client';
import { FinSpaceServiceApi } from '../api/finspaceServiceApi';
import { handleApiRequest } from '../api/utils/apiRequest';
import { createStore } from './store-factory';

interface CapabilitiesState {
  capabilities: GetCapabilitiesResponse | null;
  isLoading: boolean;
  isUpdating: boolean;
  error: any;
  fetchCapabilities: () => Promise<void>;
  updateCapability: (capabilityId: string, data: UpdateCapabilityRequest) => Promise<void>;
  setError: (error: any) => void;
}

export const useCapabilitiesStore = createStore<CapabilitiesState>('capabilities', (set, get) => ({
  capabilities: null,
  isLoading: false,
  isUpdating: false,
  error: null,
  
  fetchCapabilities: async () => {
    set({ isLoading: true, error: null });
    try {
      const result = await handleApiRequest(() => FinSpaceServiceApi.getCapabilities());
      set({ capabilities: result, isLoading: false });
    } catch (error) {
      set({ error, isLoading: false });
    }
  },
  
  updateCapability: async (capabilityId: string, data: UpdateCapabilityRequest) => {
    set({ isUpdating: true, error: null });
    try {
      await handleApiRequest(() => FinSpaceServiceApi.updateCapability(capabilityId, data));
      set({ isUpdating: false });
      // Refresh capabilities after successful update
      await get().fetchCapabilities();
    } catch (error) {
      set({ error, isUpdating: false });
    }
  },
  
  setError: (error) => set({ error }),
}));
